import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Popover } from "@arco-design/web-react";
import { IconDown } from "@arco-design/web-react/icon";
import { describeUsage } from "./fileUsage";

const lineStyle = { fontSize: 12, color: "var(--color-text-3)", lineHeight: "20px", minHeight: 20 };

// FileUsageLinks is one line saying how many places use a file (forms,
// emails, giveaways); clicking it opens the list, each a link into that
// place. A pop-up, so the card doesn't grow. usages is undefined while
// loading: the line is kept blank so cards don't change height.
export default function FileUsageLinks({ usages }) {
  if (usages === undefined) return <div style={lineStyle}>&nbsp;</div>;
  if (usages.length === 0) return <div style={lineStyle}>Not used anywhere</div>;

  const list = (
    <ul style={{ margin: 0, paddingLeft: 16, maxHeight: 280, overflowY: "auto", fontSize: 13 }}>
      {usages.map((u) => {
        const d = describeUsage(u);
        return (
          <li key={u.kind + u.id} style={{ marginBottom: 4 }}>
            {d.href ? <RouterLink to={d.href}>{d.text}</RouterLink> : d.text}
            {d.sent && " (sent)"}
          </li>
        );
      })}
    </ul>
  );
  return (
    <div style={lineStyle}>
      <Popover trigger="click" position="bl" title="Used in" content={list}>
        <button type="button"
          style={{ border: 0, background: "none", padding: 0, color: "rgb(var(--arcoblue-6))", cursor: "pointer", fontSize: 12 }}>
          Used in {usages.length} {usages.length === 1 ? "place" : "places"} <IconDown />
        </button>
      </Popover>
    </div>
  );
}
